import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

export default function NotFound() {
  const navigate = useNavigate();
  const [showLottie, setShowLottie] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLottie(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        textAlign: "center",
        background: "linear-gradient(180deg, #ffffff, #f8fafc)",
      }}
    >
      <Typography variant="h4" fontWeight={800}>
        Page not found
      </Typography>

      <Typography color="text.secondary" fontSize={14}>
        The page you're looking for doesn't exist
      </Typography>

      <Box
        sx={{
          width: 320,
          maxWidth: "90%",
          height: showLottie ? 320 : 0,
          opacity: showLottie ? 1 : 0,
          transition: "opacity 0.5s ease, height 0.5s ease",
          overflow: "hidden",
        }}
      >
        {showLottie && (
          <iframe
            src="https://lottie.host/embed/528d0060-3aa1-4210-9fdb-bef61363c6b2/qAN6moLPPq.lottie"
            style={{ width: "100%", height: "100%", border: "none" }}
            title="404 Animation"
          />
        )}
      </Box>

      <Button
        variant="contained"
        size="large"
        sx={{ mt: 1, borderRadius: 2, px: 4 }}
        onClick={() => navigate("/")}
      >
        Go Home
      </Button>
    </Box>
  );
}
